export { augmentType };
import { assert } from './assert.js';
/** Help TypeScript augment the type of objects. */
function augmentType(thing, clone) {
    // @ts-ignore
    assert(thing === clone);
}
